import {checkNameValid} from "../helper/checkNameValid";
import {checkEmailValid} from "../helper/checkEmailValid";
import {checkPasswordValid, checkPasswordConfirmValid} from "../helper/checkPasswordValid";
import {readFileImage} from "../helper/readFileImage";

let $ = jQuery;
export function formValidate() {
    $('form #name[required]').on('invalid change keyup', checkNameValid);
    $('form #email[required]').on('invalid change keyup', checkEmailValid);
    $('form #password[required], form #old_password[required]').on('invalid change keyup', checkPasswordValid);
    $('form #confirm_password[required]').on('invalid change keyup', checkPasswordConfirmValid);
    $('form #avatar').on('change', readFileImage);
}